import styled from 'styled-components'

import { type Comment } from '~/features/inquiry/types/inquiry'
import theme from '~/shared/styles/theme'

interface Props {
  comment: Comment
}

function InquiryComment({ comment }: Props) {
  return (
    <Wrapper>
      <CommentDateText>답변일 : {comment.updated_at}</CommentDateText>
      <CommentBody>{comment.comment}</CommentBody>
    </Wrapper>
  )
}

export default InquiryComment

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media ${theme.device.medium} {
    gap: 16px;
  }
`

const CommentDateText = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #838685;

  @media ${theme.device.medium} {
    font-size: 15px;
    line-height: 21px;
  }
`

const CommentBody = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 249px;
  padding: 20px 12px;

  line-height: 21px;
  white-space: pre-wrap;

  background-color: #f0f0f0;
  border-radius: 12px;

  @media ${theme.device.medium} {
    padding: 20px 10px;
    font-size: 15px;
  }
`
